<template>
  <div class="flex flex-col items-center justify-center gap-10">
    <div class="flex flex-col items-center gap-4 md:flex-row md:gap-8">
      <FontAwesomeIcon :icon="faFaceDizzy" class="text-error text-6xl" />
      <h1 class="text-error text-2xl font-bold md:text-6xl">
        {{ $t('error.server-down') }}
      </h1>
    </div>
    <p class="text-center md:text-2xl">
      {{ $t('error.server-down-description') }}
    </p>
    <button
      class="btn btn-primary"
      @click="refetchServerStatus()"
      :disabled="isFetchingServerStatus"
    >
      <FontAwesomeIcon :icon="faRotateRight" />
      {{ $t('global.reload') }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import KonsolenkostLogo from '../components/app/KonsolenkostLogo.vue';
import { faFaceDizzy, faRotateRight } from '@fortawesome/free-solid-svg-icons';
import { useServerStatus } from '../stores/serverStatusStore';

const { isFetchingServerStatus, refetchServerStatus } = useServerStatus();
</script>
